export default function TaskAttachments({
  task,
  onImageClick,
  onDelete,
}) {


if (!task.attachments?.length)
 return null;


return (

<div className="flex flex-wrap gap-3 mt-4">

{task.attachments.map(file => (

<div
 key={file.id}
 className="relative group w-28 h-28"
>


<img
 src={`${process.env.REACT_APP_BACKEND_URL}/uploads/task_attachments/${file.filename}`}
 alt=""
 className="
 rounded-lg
 border
 border-slate-700
 hover:scale-[1.02]
 transition
 cursor-pointer
 "
 onClick={() =>
   onImageClick(
    `${process.env.REACT_APP_BACKEND_URL}/uploads/task_attachments/${file.filename}`
   )
 }
/>


<button
 onClick={() =>
   onDelete(task.id,file.id)
 }
 className="
 absolute
 top-1
 right-1
 bg-black/70
 text-white
 text-xs
 w-6
 h-6
 rounded
 opacity-0
 group-hover:opacity-100
 hover:bg-red-600
 "
>
✕
</button>


</div>

))}

</div>

)

}